import styled from '@emotion/styled';
import React from 'react';
import { Fragment } from 'react';

import { FormInputLabel } from './Typography';

export enum Size {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

const TextArea = styled('textarea')`
  width: 100%;
  box-sizing: border-box;
  min-height: 6rem;
  font-size: 12px;
  line-height: 1.33;
  color: inherit;
  background-color: rgb(255, 255, 255);
  padding: 10px;
  border-width: 1px;
  border-radius: 4px;
  border-style: solid;
  border-color: rgb(198, 202, 215);
  border-image: initial;
  outline-width: 0;
  resize: vertical;

  :focus {
    border: 1px solid #1890ff;
  }
`;

const InputLabel = styled(FormInputLabel)`
  margin-top: 12px;
`;

export interface IFormTextAreaProps {
  label?: string;
  value?: string;
  disabled?: boolean;
  required?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  style?: {};
  size?: 'small' | 'medium' | 'large';
  placeholder?: string;
  hiddenLabel?: boolean;
}

const FormTextArea = (props: IFormTextAreaProps) => {
  const { label } = props;
  return (
    <Fragment>
      {label && (<InputLabel bold>
        {' '}
        {label ? label.toUpperCase() : ''}{' '}
      </InputLabel>)
      }
      <TextArea {...props}></TextArea>
    </Fragment>
  );
};

export default FormTextArea;
